import list_ApiUrl from "../compartida/listApiUrl";

export default {
  rol_admin: {
    usuario: {
      get: function (parametros) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_USUARIOS, {
          params: parametros,
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      post: function (data) {
        return axios.post(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_USUARIOS, data, {
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      put: function (data) {
        return axios.put(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_USUARIOS + '/' + data.id, data, {
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      eliminar: function (data) {
        return axios.delete(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_USUARIOS + '/' + data.id, {
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      }
    },
    cliente: {
      get: function (parametros) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_CLIENTES, {
          params: parametros,
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      post: function (data) {
        return axios.post(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_CLIENTES, data, {
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      put: function (data) {
        return axios.put(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_CLIENTES + '/' + data.id, data, {
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      eliminar: function (data) {
        return axios.delete(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_CLIENTES + '/' + data.id, {
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      }
    },
  },
  rol_regular: {
    clientes: {
      getClientes: function () {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CLIENTES, {headers: list_ApiUrl.TOKEN_HEADERS});
      }
    },
    categorias: {
      getCategorias: function (parametros) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CATEGORIAS, {
          params: parametros,
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      getUnaCategorias: function (data) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CATEGORIAS + '/' + data.id, {headers: list_ApiUrl.TOKEN_HEADERS});
      },
      getEtiquetasDeUnaCategorias: function (data) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_ETIQUETA_CATEGORIAS + list_ApiUrl.API_URL_ETIQUETA_DE_UNA_CATEGORIA + '/' + data, {headers: list_ApiUrl.TOKEN_HEADERS});
      },
      getListarCategorias: function (parametros) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CATEGORIAS + list_ApiUrl.ROL_URL_LISTAR_CATEGORIAS, {
          params: parametros,
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      postCategorias: function (data) {
        console.log(data);
        return axios.post(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CATEGORIAS, data, {
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      postEtiquetaCategorias: function (data) {
        console.log(data);
        return axios.post(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_ETIQUETA_CATEGORIAS + '/' + data.id, data, {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.getItem('tok_header1') + '.' + localStorage.getItem('tok_header2') + '.' + localStorage.getItem('toke_id')
          }
        });
      },
      deleteCategorias: function (data) {
        console.log(data);
        return axios.delete(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CATEGORIAS + '/' + data.id, {
          params: data.parametro,
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      putCategorias: function (data, id) {
        return axios.post(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CATEGORIAS + '/' + id, data, {headers: list_ApiUrl.TOKEN_HEADERS});
      },
      putOrdenCategorias: function (data) {
        return axios.put(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CATEGORIAS + '/' + data.id, data, {headers: list_ApiUrl.TOKEN_HEADERS});
      }
    },
    contenidos: {
      getContenidos: function (parametros) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CONTENIDOS, {
          params: parametros,
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      getUnContenidos: function (parametro) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CONTENIDOS + '/' + parametro, {
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      postContenidos: function (data) {
        return axios.post(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CONTENIDOS, data, {headers: list_ApiUrl.TOKEN_HEADERS});
      },
      deleteContenidos: function (data) {
        return axios.delete(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CONTENIDOS + '/' + data, {headers: list_ApiUrl.TOKEN_HEADERS});
      },
      putContenidos: function (data) {
        return axios.put(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_CONTENIDOS + '/' + data.id, data, {headers: list_ApiUrl.TOKEN_HEADERS});
      }
    },
    etiquetas: {
      getEtiquetas: function (parametros) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_ETIQUETAS, {
          params: parametros,
          headers: list_ApiUrl.TOKEN_HEADERS
        });
      },
      getListaEtiquetas: function (data) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_ETIQUETAS + '/' + data, {headers: list_ApiUrl.TOKEN_HEADERS});
      },
      postEtiqueta: function (data) {
        console.log(data);
        return axios.post(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_ETIQUETAS, data, {headers: list_ApiUrl.TOKEN_HEADERS});
      },
      putEtiqueta: function (data) {
        return axios.put(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_ETIQUETAS + '/' + data.id, data, {headers: list_ApiUrl.TOKEN_HEADERS});
      },
      Delete: function (data) {
        return axios.delete(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_ETIQUETAS + '/' + data.id, {headers: list_ApiUrl.TOKEN_HEADERS});
      }
    },
    masAyudas: {
      getMasAyudasPublico: function (parametro) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_PUBLICO + list_ApiUrl.API_URL_MAS_AYUDAS + '/' + parametro);
      },
      getMasAyudas: function (parametro) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_MAS_AYUDAS + '/' + parametro, {headers: list_ApiUrl.TOKEN_HEADERS});
      },
      putMasAyudas: function (parametro) {
        return axios.put(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_MAS_AYUDAS + '/' + parametro.categoria_id + '/' + parametro.contenido_id, parametro,
          {
            headers: list_ApiUrl.TOKEN_HEADERS
          }
        );
      },
    },
    estilos: {
      get: function (cliente) {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.API_URL_PUBLICO + list_ApiUrl.API_URL_ESTILO + '/' + cliente);
      },
      getRegular: function () {
        return axios.get(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_ESTILO + '/panel/todos', {headers: list_ApiUrl.TOKEN_HEADERS});
      },
      post: function (data) {
        return axios.post(list_ApiUrl.BASE_URL_PRODUCCION + list_ApiUrl.ROL_URL_REGULAR + list_ApiUrl.API_URL_ESTILO, data, {headers: list_ApiUrl.TOKEN_HEADERS});
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/privada/servicioApi.js